export const sendToWhatsApp = (message) => {
  const businessNumber = process.env.REACT_APP_WHATSAPP_NUMBER;
  const url = `https://wa.me/${businessNumber}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};
